import React from 'react';

export const MobileContext = React.createContext({
  isMobile: false,
  setIsMobile: () => {},
});
